import { User } from '@marketing-milk/interfaces'

/** Collapsed, ten identical glyphs in one column read as a list you count
 *  rather than one you recognise. The rail rules between groups. */
export type NavGroup = 'run' | 'plan' | 'external'

export interface NavLinkI {
  url: string
  icon: string
  label: string
  group: NavGroup
  visible?: boolean
  externalLink?: string
}

export function getNavLinks(busID: string | number = 0, user?: User): NavLinkI[] {
  const newAppBase = process.env.REACT_APP_NEW_APP_URL
  const newAppLink = newAppBase
    ? busID
      ? `${newAppBase}/${busID}/meta/marketing-funnel`
      : newAppBase
    : undefined

  return [
    {
      label: 'Campaigns',
      icon: 'megaphone',
      url: `${busID}/campaigns`,
      group: 'run',
    },
    {
      label: 'Audiences',
      icon: 'book-user',
      url: `${busID}/audiences`,
      group: 'run',
    },
    {
      label: 'Creatives',
      icon: 'images',
      url: `${busID}/creatives`,
      group: 'run',
    },
    {
      label: 'Lead Cards',
      icon: 'address-card',
      url: `${busID}/lead-cards`,
      group: 'run',
    },
    {
      label: 'Sprints',
      icon: 'calendar',
      url: `${busID}/sprints`,
      group: 'plan',
    },
    {
      label: 'Sprint Packets',
      icon: 'clipboard',
      url: `${busID}/sprint-packets`,
      group: 'plan',
    },
    {
      label: 'Local Competition',
      icon: 'radar',
      url: `${busID}/competition`,
      group: 'plan',
    },
    {
      label: 'AI Studio',
      icon: 'magic',
      url: `${busID}/ai-studio`,
      group: 'plan',
    },
    {
      label: 'Analytics',
      icon: 'chart-line',
      url: 'marketing-milk',
      externalLink: newAppLink,
      visible: Boolean(newAppBase),
      group: 'external',
    },
  ]
}
